export interface ClusterData {
  id?: string;
  winner?: boolean;
  size?: number;
}

export namespace ClusterData {
  export function fromItem(itemId: string, clusterId: string, winnerId: string, size: number): ClusterData {
    return {
      id: clusterId,
      winner: itemId === winnerId,
      size,
    };
  }
}
